import React from 'react'

import PropTypes from 'prop-types'
import {Redirect} from 'react-router-dom'
import {useSelector} from 'react-redux'

import {makeStyles} from '@material-ui/core/styles'
import {AppBar, Container, Tab, Tabs} from '@material-ui/core'
import Box from "@material-ui/core/Box";

import Page from 'components/Page/Page'

import DailySummaries from './DailySummaries.js'
import CalRecycleMonthlyReport from './CalRecycleMonthlyReport.js'
import Logs from './Logs.js'
import DR6 from './DR6.js'
import DR14 from './DR14.js'
import EcosackReport from './EcosackReport.js'
import RIG3Report from './RIG3Report.js'


const useStyles = makeStyles((theme) => ({}))

const ReportingPage = ({children}) => {
  const auth = useSelector(state => state.auth)
  const classes = useStyles()

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
      <div {...other}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }

  if (!auth.access_token) {
    return <Redirect to="/login"/>
  }

  function hasPermission(perm) {
    for (var i = 0; i < auth.permissions.length; i++) {
      if (auth.permissions[i][0] == perm[0] && auth.permissions[i][1] == perm[1]) {
        return true
      }
    }
    return false
  }

  const isAdmin = hasPermission(["Admin", "admin"])
  const isAdminOrUser = isAdmin || hasPermission(["Normal", "user"])

  // DR6, DR14, RIG3 and the CalRecycle monthly report are California (CalRecycle)
  // reports - New York tenants don't file them
  const isNY = auth.tenant?.state == "NY"

  const reports = [
    {label: "Daily Summaries", allowed: isAdminOrUser, component: <DailySummaries/>},
    {label: "CalRecycle Monthly Report", allowed: isAdminOrUser, component: <CalRecycleMonthlyReport/>, californiaOnly: true},
    {label: "Logs", allowed: isAdminOrUser, component: <Logs/>},
    {label: "DR6", allowed: isAdminOrUser, component: <DR6/>, californiaOnly: true},
    {label: "DR14", allowed: isAdminOrUser, component: <DR14/>, californiaOnly: true},
    {label: "Ecosack", allowed: isAdmin, component: <EcosackReport/>},
    {label: "RIG3 Report", allowed: isAdminOrUser, component: <RIG3Report/>, californiaOnly: true},
  ].filter(report => !(isNY && report.californiaOnly))

  return (
    <Page title="Reporting">
      <Container maxWidth={false}>

        <AppBar position="static">
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" variant="scrollable">
            {reports.map(report => <Tab key={report.label} label={report.label}/>)}
          </Tabs>
        </AppBar>

        {reports.map((report, index) => (
          <TabPanel key={report.label} value={value} index={index}>
            {report.allowed && report.component}
          </TabPanel>
        ))}

      </Container>
    </Page>
  )
}

export default ReportingPage

ReportingPage.propTypes = {
  children: PropTypes.node
}